import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, CreditCard, X } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TrialExpiredModal = () => {
  const { trialExpired, clearTrialExpired } = useAuth();
  const navigate = useNavigate();

  const handleUpgrade = () => {
    clearTrialExpired();
    navigate('/subscription');
  };

  return (
    <AnimatePresence>
      {trialExpired && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative bg-zinc-900 border border-zinc-800 rounded-lg p-8 max-w-md mx-4 text-center"
          >
            <button
              onClick={clearTrialExpired}
              className="absolute top-4 right-4 text-zinc-500 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <AlertTriangle className="w-8 h-8 text-red-500" />
            </div>

            <h2 className="text-2xl font-heading text-white mb-3">
              Your Free Trial Has Ended
            </h2>

            <p className="text-zinc-400 mb-6">
              Your 30-day free trial has expired. Upgrade now to continue using Black Arrow MMA 
              and keep developing your fighters with our professional tools.
            </p>

            <div className="space-y-3">
              <Button
                onClick={handleUpgrade}
                className="w-full bg-red-600 hover:bg-red-700 text-white"
              >
                <CreditCard className="w-4 h-4 mr-2" />
                Upgrade Now
              </Button>
              
              <Button
                onClick={clearTrialExpired}
                variant="outline"
                className="w-full border-zinc-700 text-zinc-400 hover:text-white"
              >
                Maybe Later
              </Button>
            </div>

            <p className="text-xs text-zinc-500 mt-4">
              You can still view your data, but creating or editing content is restricted.
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TrialExpiredModal;
